// extracted by mini-css-extract-plugin
export default {"form":"CartForm_form__jLW09","details":"CartForm_details__8bo94"};